import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-CloseBadge",
  "use": "svg-icon-CloseBadge-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"svg-icon-CloseBadge\"><path fill-rule=\"evenodd\" d=\"M7.5 0a7.5 7.5 0 1 0 .002 15.002A7.5 7.5 0 0 0 7.5 0m4.412 10.313l-1.572 1.571-2.812-2.812-2.813 2.812-1.572-1.572L5.956 7.5 3.143 4.687l1.572-1.571 2.813 2.812 2.812-2.812 1.572 1.571L9.099 7.5l2.813 2.813\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol